export const convertObjectValuesToStrings = (obj: { [key: string]: any }): { [key: string]: string } => {
  const result: { [key: string]: string } = {};

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = String(obj[key]);
    }
  }

  return result;
};
